<template>
    <div>
        <loadingScreen/>
        <!-- Natal: neve na tela inteira passando por cima dos cards (sem receber clique); no claro, com sombra verde -->
        <div v-if="christmasSeason && christmasEffects" class="home-snow" aria-hidden="true">
            <christmas-snow :density="1" :max-size="9" :speed="0.9" :shaded="darkTheme !== 'ativo'"></christmas-snow>
        </div>
        <page-header title="Home" @setSystem="alterSystem($event)" :system="sistems"></page-header>
        <!-- Natal: cartão fino de festas; fechar guarda no selo do cabeçalho -->
        <christmas-greeting v-if="christmasSeason"></christmas-greeting>
        <cardDocumentsComponent @toRoute="toRoute">
            <template #cards>
                <card-now-moment-component @toRoute="toRoute"></card-now-moment-component>
                <card-assigns-by-day-component @getResum="getResum" @toRoute="toRoute">
                    <template #personalizedDate v-if="this.dateFinalPersonalized && this.dateInitialPersonalized">
                        <p class="font-weight-bolder" style="font-size: smaller; color: grey">Documentos entre {{ formatDatePersonalized() }}</p>
                    </template>
                </card-assigns-by-day-component>
            </template>
        </cardDocumentsComponent>
        <card-grafic-resum-assing-component @changeTypeDoc="changeTypeDoc">
            <template #graficPlot>
                <div id="chartAssigns"></div>
            </template>
            <template #buttonsAlterDay>
                <div class="btn btn-primary mr-2"
                     @click="getGraficDashboard({isDay: true, sistems: this.sistems, onlyDocs:this.onlyDocGrafic});grapicDay = true"
                     :class="grapicDay ?'active' :''">
                    <i v-if="grapicDay"
                       class="icon-check-circle">
                    </i>
                    {{ t('HOME.LAST_30_DAYS') }}
                </div>
                <div class="btn btn-primary "
                     :class="grapicDay ?'' :'active'"
                     @click="getGraficDashboard({isDay: false, sistems: this.sistems, onlyDocs:this.onlyDocGrafic});grapicDay = false">
                    <i v-if="!grapicDay"
                       class="icon-check-circle">
                    </i>
                    {{ t('HOME.LAST_12_MONTHS') }}
                </div>
            </template>
        </card-grafic-resum-assing-component>
        <modal-component :title-modal="titleModal"
                         @close="wichModal= null; dateInitialPersonalized = null; dateFinalPersonalized = null">
            <template #title>{{ titleModal }}</template>
            <div v-if="wichModal === 1">
                <div class="modal-body">
                    <div class="row gutters">
                        <div class="form-group col-6">
                            <label for="dateInitialPersonalized" class="required">Data Início</label>
                            <input type="date" class="form-control" id="dateInitialPersonalized"
                                   v-model="dateInitialPersonalized">
                        </div>
                        <div class="form-group col-6">
                            <label for="dateFinalPersonalized" class="required">Data Final</label>
                            <input type="date" id="dateFinalPersonalized" class="form-control"
                                   v-model="dateFinalPersonalized">
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="btn btn-primary" @click="filterDatePersonalized">Filtrar</div>
                </div>
            </div>
        </modal-component>
    </div>
</template>

<script>
import LoadingScreen from '@/components/layouts/loadScreenComponent';
import PageHeader from '@/components/layouts/pageHeader';
import {mapActions, mapState, mapMutations} from 'vuex';
import {useToast} from "vue-toastification";
import {useI18n} from "vue-i18n";
import ApexCharts from 'apexcharts';
import cardNowMomentComponent from '@/pages/home/.partials/cardNowMomentComponent';
import cardAssignsByDayComponent from '@/pages/home/.partials/cardAssignsByDayComponent';
import cardDocumentsComponent from '@/pages/home/.partials/cardDocumentsComponent';
import cardGraficResumAssingComponent from '@/pages/home/.partials/cardGraficResumAssingComponent';
import modalComponent from '../../components/layouts/modalComponent';
import moment from 'moment';
import ChristmasSnow from '@/components/christmas/ChristmasSnow.vue';
import ChristmasGreeting from '@/pages/home/.partials/ChristmasGreeting.vue';

export default {
    name: 'HomeComponent',
    components: {
        LoadingScreen,
        PageHeader,
        cardNowMomentComponent,
        cardAssignsByDayComponent,
        cardDocumentsComponent,
        cardGraficResumAssingComponent,
        modalComponent,
        ChristmasSnow,
        ChristmasGreeting,
    },
    beforeRouteLeave(to, from, next) {
        this.chartGraphicAssign?.destroy();
        return next();
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data() {
        return {
            chartGraphicAssign: null,
            daysFilter: '7',
            grapicDay: true,
            sistems: 'all',
            onlyDocGrafic: 'all',
            titleModal: '',
            wichModal: null,
            dateInitialPersonalized: null,
            dateFinalPersonalized: null,
        }
    },
    computed: {
        ...mapState({
            dataGrafic: (state) => state.home.dataGrafic,
            christmasSeason: 'christmasSeason',
            christmasEffects: 'christmasEffects',
            darkTheme: 'darkTheme',
        })
    },
    mounted() {
        this.getCountPendingSign({sistems: this.sistems});
        this.getCountStatusAssign({sistems: this.sistems});
        this.getGraficDashboard({isDay: true, sistems: this.sistems, onlyDocs: this.onlyDocGrafic});
    },
    watch: {
        dataGrafic(result) {
            if (Object.keys(result)?.length) {
                this.renderChartAssing(result);
            } else {
                this.chartGraphicAssign?.destroy();
            }
        }
    },
    methods: {
        ...mapActions({
            getCountPendingSign: 'getCountPendingSign',
            getCountStatusAssign: 'getCountStatusAssign',
            getCountStatusAssignByDate: 'getCountStatusAssignByDate',
            getGraficDashboard: 'getGraficDashboard',
        }),
        ...mapMutations({
            setFilterHome: 'setFilterHome'
        }),
        formatDatePersonalized() {
            return moment(this.dateInitialPersonalized).format('DD-MM-YYYY') + ' até ' + moment(this.dateFinalPersonalized).format('DD-MM-YYYY');
        },
        changeTypeDoc({id}) {
            this.onlyDocGrafic = id;
            this.getGraficDashboard({isDay: this.grapicDay, sistems: this.sistems, onlyDocs: id});
        },
        alterSystem(system) {
            this.sistems = system;
            this.getCountPendingSign({sistems: this.sistems});
            this.getCountStatusAssignByDate({days: this.daysFilter, sistems: this.sistems});
            this.getGraficDashboard({isDay: this.grapicDay, sistems: this.sistems, onlyDocs: this.onlyDocGrafic});
        },
        toRoute(name) {
            if (name === 'Running' || name === 'PendingAdm' || name === 'All') {
                this.setFilterHome({last_days: 'all', sistems: this.sistems});
            } else {
                this.setFilterHome({last_days: this.daysFilter, sistems: this.sistems});
            }
            this.$router.push({name})
        },
        getResum(days) {
            this.dateInitialPersonalized = null;
            this.dateFinalPersonalized = null;
            if (days === 'personalized') {
                this.daysFilter = days;
                let div = document.createElement('div');
                div.setAttribute('data-toggle', 'modal');
                div.setAttribute('data-target', '#customModalTwo');
                let body = document.getElementsByTagName('body')[0];
                body.appendChild(div);
                setTimeout(function () {
                    div.click();
                    div.remove();
                }, 100);
                this.titleModal = 'Selecione uma data';
                this.wichModal = 1;
                return
            }
            this.daysFilter = days;
            this.getCountStatusAssignByDate({days: this.daysFilter, sistems: this.sistems});
        },
        filterDatePersonalized() {
            if (!this.dateFinalPersonalized || !this.dateInitialPersonalized) {
                this.toast.error('Nescessario informar data de inicio e fim');
                return
            }
            if (moment(this.dateInitialPersonalized).isAfter(this.dateFinalPersonalized)) {
                let aux = this.dateFinalPersonalized;
                this.dateFinalPersonalized = this.dateInitialPersonalized;
                this.dateInitialPersonalized = aux;
            }
            this.daysFilter = `personalized.${this.dateInitialPersonalized}.${this.dateFinalPersonalized}`;
            this.getCountStatusAssignByDate({days: this.daysFilter, sistems: this.sistems});
            const modal = document.getElementById('customModalTwo');
            if (modal) {
                const closeButton = modal.querySelector('#closeX');
                if (closeButton) {
                    const clone = closeButton.cloneNode(true);
                    closeButton.replaceWith(clone);
                    clone.click();
                }
            }
            this.wichModal = null;
            this.titleModal = '';
        },
        renderChartAssing(result) {
            let seriesAssign = [];
            seriesAssign.push({
                name: result.name1,
                data: result.assinaturas
            });
            seriesAssign.push({
                name: result.name2,
                data: result.assinados
            });
            seriesAssign.push({
                name: 'Aguardando',
                data: result.aguardando
            });
            seriesAssign.push({
                name: result.name4,
                data: result.cancelados
            });
            seriesAssign.push({
                name: result.name5,
                data: result.expirados
            });
            let chartOptionsAssign = {
                chart: {
                    height: '100%',
                    type: 'area',
                    width: '100%',
                    defaultLocale: 'pt',
                    locales: [{
                        name: 'pt',
                        options: {
                            toolbar: {
                                download: 'Download SVG',
                                selection: 'Selecionar',
                                selectionZoom: 'Selecionar Zoom',
                                zoomIn: 'Aumentar Zoom',
                                zoomOut: 'Reduzir Zoom',
                                pan: 'Panorama',
                                reset: 'Resetar Zoom',
                            }
                        }
                    }]
                },
                responsive: [
                    {
                        breakpoint: 1000,
                        options: {
                            legend: {
                                position: "bottom"
                            }
                        }
                    }
                ],
                legend: {
                    position: 'top',
                    horizontalAlign: 'center',
                },
                noData: {
                    text: 'Nenhum dado para ser carregado',
                    align: 'center',
                    verticalAlign: 'middle',
                },
                series: seriesAssign,
                xaxis: {
                    convertedCatToNumeric: false,
                    categories: result.categories
                },
                colors: ['#36848d', '#2e644a', '#092f6b', '#9d1c1c', '#584d07'],
            };
            let elChartAssign = document.getElementById('chartAssigns');
            this.chartGraphicAssign?.destroy();
            this.chartGraphicAssign = new ApexCharts(elChartAssign, chartOptionsAssign);
            this.chartGraphicAssign.render();
            this.$store.commit('changeLoading', false);
        }
    }
}
</script>

<style>
/* Natal: neve por cima dos cards e abaixo do cabeçalho (z-index 100) e dos modais; não recebe clique */
.home-snow {
    position: fixed;
    inset: 0;
    z-index: 50;
    pointer-events: none;
}
</style>
